import * as css from './TooltipAbsolute.css';

function TooltipAbsolute({text, dataTitleIcon,icon,show=false,bottom=false}) {
    return (
        <css.tooltip data-cy = 'inputPopMessage' $dataTitleIcon={dataTitleIcon} $show={show} $icon={icon} $dataText={text} $bottom={bottom} />
    );
}
export default TooltipAbsolute;
